import {
  hideMessage,
  showAuthLoader,



  userSignIn
} from "actions/Auth";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getPubByUidApi } from "../api/util";
import PubPreviewCard from "../app/routes/Component/dialog/PubPreviewCard";
import ProcessTable from "../app/routes/Component/process/ProcessTable.";
import { CircularProgress } from "@material-ui/core";


class ItemPreviewPage extends React.Component {
  constructor() {
    super();
    this.state = {
      pub: {},
      isLangInput: false,
      fileList: [],
      process: [],
      error:false,
      selectedProject: null,
      itemLangList: [],
      loading:true
    };
  }

   async componentDidMount() {
    this.setState({loading:true})
    const uid = this.props.match.params.uid;

    const result =  await getPubByUidApi(uid);
    if (result.status) {
       this.setState({ pub: result.data.pub, 
        process: result.data.process , 
         fileList: result.data.fileList ,
         loading:false
        });
        
    }


  }




  render() {
    const { pub, process  , fileList , loading } = this.state;


    return (
      <div className="app-wrapper" style={{
        height: '100vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div className="content-wrapper" style={{
          flex: 1,
          padding: '20px'
        }}>
          <div className="row justify-content-center mb-3">
            <Link to="/">
              <img
                src={require("assets/images/yaysis_logo/sonLogo2.png")}
                alt="Yaysis"
                title="Yayın Yönetim Sistemi"
              />
            </Link>
          </div>

     
          
          <h3 className="m-3 text-center text-danger">
            {pub.title} Eser / Makale Detayı 
          </h3>
         { loading ?  <CircularProgress /> :  <PubPreviewCard 

            
              pub={pub} 
              fileList={fileList} 
              visibility={true} 
              previewRole={""} 
            />}

<h3 className="m-3 text-center text-danger">
            "{pub.title}" Yaysis İşlem Geçmişi
          </h3>

          <ProcessTable
            processList={process}
            isAdmin={false}
            showComment={false}
            classStyle="overflow-auto col-md-12 col-xs-12 col-sm-12"
          />
          
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth  }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;

  return { loader, alertMessage, showMessage, authUser  };
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
})(ItemPreviewPage);
